import React, {Component} from 'react';
import NavBar from '../components/navbar';
import ProjectCard from '../components/ProjectCard';
import {Typography, IconButton} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';


const useStyles= theme =>({
  root:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
  },
  title:{
    fontFamily:['Nunito'].join(','),
    color:'#153BAB',
    paddingBottom:'10px',
    marginLeft:'30px',


  },
  info:{
    paddingBottom:'30px',
    fontFamily:['Nunito'].join(','),
    fontWeight:400,
    marginLeft:'30px',
    maxWidth:'70%',
    color:'black'
  },
  iconBar:{
    display:'flex',
    flexDirection:'row',
    padding:'10px 10px',
  },
  arrowIcon:{
    flexGrow:1,
  },
  Horizontalcontainer:{
    display:'flex',
    flexDirection:"column",

  },
  sideContainer:{
    display:'flex',


  },
  verticalContainer:{
    display:'flex',
    flexDirection:"row",

  },

  TabProjects:{
    fontWeight: 'bold',
    color: '#000000' ,
    fontSize: '20px',
    textShadow: '0px 0px 0px #000000',
    boxShadow: '0px 0px 0px #FFFFFF' ,
    padding: '10px 10px',
    borderRadius: '0px',
    background: '#FFFFFF',
  },
  iconBtn:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
    marginRight:'10px',
    marginTop:'-10px'
  },
  icon:{
    height:'35px',
    width:'35px',
  }


});

// static data
// const projects = [
//   {
//     "description" : "BA/MS in a quantitative discipline Minimum of 12 years of relevant experience, with at least 3+ years of client development and engagement a MUST Prior experience working with data quality, fraud detection/prevention, and business improvement initiatives Proficiency with analytical tools, such as R/R Studio, SPSS, SAS, or advanced data quality/fraud analysis toolkits preferred Experience designing and developing analytic algorithms and techniques in support of robotic processing automation, machine learning, etc. Strong analytical skills with a focus on critical thinking, problem-solving, numeric reasoning, and creativity Ability to think big picture strategy in assessing client business problems and developing corresponding solutions Keywords: data scientist, machine learning, advanced analytics, Python, fraud detection, consulting",
//     "employer_id" : "12341234xd",
//     "startdate" : "5/5/2021"
//   },
//   {
//     "description" : "BA/MS in a quantitative discipline Minimum of 12 years of relevant experience, with at least 3+ years of client development and engagement a MUST Prior experience working with data quality, fraud detection/prevention, and business improvement initiatives Proficiency with analytical tools, such as R/R Studio, SPSS, SAS, or advanced data quality/fraud analysis toolkits preferred Experience designing and developing analytic algorithms and techniques in support of robotic processing automation, machine learning, etc. Strong analytical skills with a focus on critical thinking, problem-solving, numeric reasoning, and creativity Ability to think big picture strategy in assessing client business problems and developing corresponding solutions Keywords: data scientist, machine learning, advanced analytics, Python, fraud detection, consulting",
//     "employer_id" : "12341234xd",
//     "startdate" : "5/5/2021"
//   },
//   { "description" : "BA/MS in a quantitative discipline Minimum of 12 years of relevant experience, with at least 3+ years of client development and engagement a MUST Prior experience working with data quality, fraud detection/prevention, and business improvement initiatives Proficiency with analytical tools, such as R/R Studio, SPSS, SAS, or advanced data quality/fraud analysis toolkits preferred Experience designing and developing analytic algorithms and techniques in support of robotic processing automation, machine learning, etc. Strong analytical skills with a focus on critical thinking, problem-solving, numeric reasoning, and creativity Ability to think big picture strategy in assessing client business problems and developing corresponding solutions Keywords: data scientist, machine learning, advanced analytics, Python, fraud detection, consulting",
//     "employer_id" : "12341234xd",
//     "startdate" : "5/5/2021",
//     "talents" : {
//       "12341234xd" : "Joe"
//     }
//   }
// ]


class TalentProjects extends Component{
  constructor(props) {
    super(props);
 
    this.state = {
      talent: [],
    };
  }
 
  componentDidMount() {
  fetch(process.env.REACT_APP_IP+'talent/projects/12341234xd', {
      method: "get",
      headers: {
        'Accept': 'application/json'
      }
    }).then(response => response.json())
    .then(data => this.setState({ talent: data.talent})) 
  }
 
  render (){
    const {classes} = this.props;
    return(
      <div className={classes.root}>
      <NavBar type="exam"/>
      <div className={classes.verticalContainer}>
      <div className={classes.sideContainer}>
      {/* <SideBar /> */}
      </div>
      {this.state.talent.map((project, index) => (
          <div key={index}>
      <div className={classes.Horizontalcontainer}>
        <center>
        <div className={classes.iconBar}>
        <IconButton className={classes.iconBtn}><ArrowBackIcon className={classes.icon}/></IconButton>
          <div className={classes.arrowIcon}>
          <a href="/" className={classes.TabProjects}>
            Project Details
          </a>
          </div>
          <div className={classes.arrowIcon}>
          <a href="/" className={classes.TabProjects}>
            Team
          </a>
          </div>
        </div>
        </center>
        <div>
        <ProjectCard name="Project X"/>
          <br /><br />
      <Typography className={classes.title}><strong>{project.description}</strong></Typography>
          <Typography className={classes.info}><strong>{this.props.about}</strong></Typography>
          </div>
          
          <div style={{marginTop:'50px'}}>
          {/* < Footer /> */}
          </div>
        </div>
        </div>))}
      </div>
      </div>

    );
  }
}
export default withStyles(useStyles)(TalentProjects);
